import { CSSProperties } from 'react';
import { COLORS, FONTS } from '../../globalStyles';

export const styles: Record<string, CSSProperties> = {
  inner: {
    display: 'grid',
    gridTemplateColumns: '1fr 1.5fr',
    gap: '5rem',
    alignItems: 'start',
    marginTop: '3.5rem',
  },
  infoPara: {
    color: COLORS.muted,
    fontSize: '0.9375rem',
    lineHeight: 1.75,
    marginBottom: '2rem',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.9rem',
  },
  detailItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    fontSize: '0.8rem',
    color: COLORS.muted,
    fontFamily: FONTS.body,
  },
  dot: {
    width: '6px',
    height: '6px',
    borderRadius: 0,
    background: COLORS.accent,
    transform: 'rotate(45deg)',
    flexShrink: 0,
  },
  link: {
    color: COLORS.accent,
    textDecoration: 'none',
  },
};
